import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UserAccessModel } from '../../shared/models/user-access.model';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../shared/services/user.service';
import { NotificationModel } from '../../shared/models/notification.model';
import { Subscription } from 'rxjs';
import { MaterialModule } from '../../shared/material.module';
import { NotificationsComponent } from '../notifications/notifications.component';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ClickOutsideModule } from 'ng-click-outside';

@Component({
  selector: 'app-top-nav',
  standalone: true,
  imports: [
    MaterialModule,
    NotificationsComponent,
    NgIf,
    RouterLink,
    ClickOutsideModule
  ],
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit, OnDestroy {

  @Input() user: UserAccessModel | null;
  lightTheme: boolean;
  notifications: NotificationModel[];
  isNotificationOpened = false;

  private notificationsSub: Subscription;

  constructor(private authService: AuthService, private userService: UserService) { }

  ngOnInit(): void {
    this.authService.lightTheme.subscribe(lightTheme => this.lightTheme = lightTheme);
    this.getNotifications();
  }

  ngOnDestroy(): void {
    if (this.notificationsSub) { this.notificationsSub.unsubscribe(); }
  }

  logout(): void {
    this.authService.logOut();
  }

  switchMode(): void {
    this.authService.switchMode(!this.lightTheme);
  }

  getNotifications(): void {
    if ( !this.user ) { return; }
    this.notificationsSub = this.userService.getNotifications(this.user.id).subscribe(notifications => this.notifications = notifications);
  }

  clickOutside(): void {
    if (this.isNotificationOpened) {
      this.isNotificationOpened = false;
    }
  }
}
